import { useMemo } from 'react';
import { useEmployeeOrders } from '@/api/employees/employees.queries';
import type { EmployeeWithBeneficiariesFormatted } from '@/api/employees/employees.types';
import { Table } from '@/components/table/Table';
import { useTableState } from '@/components/table/useTableState';
import { createAttachColumn, ordersColumns, paymentColumns } from '../columns/orders-columns';

const NEWEST_FIRST = [{ id: 'date', desc: true }];

interface EmployeeOrdersProps {
  employee: EmployeeWithBeneficiariesFormatted;
}

export function EmployeeOrders(props: EmployeeOrdersProps) {
  const { employee } = props;
  const { data, isLoading, isError } = useEmployeeOrders(employee.id);
  const columns = useMemo(
    () => [...ordersColumns, ...paymentColumns, createAttachColumn(employee.id)],
    [employee.id]
  );
  const tableState = useTableState('employee-orders', {
    columns,
    initialSorting: NEWEST_FIRST,
  });

  const failedCount = data?.failedCount ?? 0;

  return (
    <div className="flex flex-col gap-2">
      {failedCount > 0 && (
        <p className="text-sm text-red-600">
          {failedCount} commande{failedCount > 1 ? 's' : ''} sur {data?.totalCount} n
          {failedCount > 1 ? "'ont" : "'a"} pas pu être récupérée{failedCount > 1 ? 's' : ''} auprès
          de la billetterie.
        </p>
      )}
      <Table
        entity={{
          singular: 'commande billetterie',
          plural: 'commandes billetterie',
          feminine: true,
        }}
        data={data?.orders}
        columns={columns}
        tableState={tableState}
        isLoading={isLoading}
        isError={isError}
        fullscreenTable
      />
    </div>
  );
}
